<template>
  <div
    class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
  >
    <!-- Showing results text -->
    <p class="mb-0 text-paragraph">
      Showing
      <span class="fw-bold">{{ pagination.from }}</span>
      out of
      <span class="fw-bold">{{ pagination.total }}</span>
      results
    </p>

    <!-- Pagination nav -->
    <nav class="mt-15 mt-md-0">
      <ul class="pagination mb-0">
        <!-- Prev Button -->
        <li class="page-item" v-if="pagination.current_page > 1">
          <a
            class="page-link"
            href="#"
            aria-label="Previous"
            @click.prevent="changePage(pagination.current_page - 1)"
          >
            <i class="flaticon-chevron-1"></i>
          </a>
        </li>

        <!-- Page Numbers -->
        <li v-for="page in pagesNumber" :key="page" class="page-item">
          <a
            class="page-link"
            :class="{ active: page === pagination.current_page }"
            href="#"
            @click.prevent="changePage(page)"
          >
            {{ page }}
          </a>
        </li>

        <!-- Next Button -->
        <li
          class="page-item"
          v-if="pagination.current_page < pagination.last_page"
        >
          <a
            class="page-link"
            href="#"
            aria-label="Next"
            @click.prevent="changePage(pagination.current_page + 1)"
          >
            <i class="flaticon-chevron"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

interface Pagination {
  current_page: number;
  last_page: number;
  from: number;
  to: number;
  total: number;
}

export default defineComponent({
  name: "PaginatorContent",
  props: {
    pagination: {
      type: Object as PropType<Pagination>,
      required: true,
    },
    offset: {
      type: Number,
      default: 3,
    },
  },
  emits: ["paginate"],
  setup(props, { emit }) {
    const pagesNumber = computed(() => {
      if (!props.pagination.to) return [];

      let from = props.pagination.current_page - props.offset;
      if (from < 1) from = 1;

      let to = from + props.offset * 2;
      if (to >= props.pagination.last_page) {
        to = props.pagination.last_page;
      }

      const pagesArray: number[] = [];
      for (let page = from; page <= to; page++) {
        pagesArray.push(page);
      }
      return pagesArray;
    });

    function changePage(page: number) {
      emit("paginate", page);
    }

    return { changePage, pagesNumber };
  },
});
</script>
